import { TypographyHeading, TypographyParagraph } from '../typography'
// @ts-ignore
import monaLisa from '#images/mona.webp'
import { twMerge } from 'tailwind-merge'
import Image from './Image'
import clsx from 'clsx'

const EventCard = ({
	name = 'Unknown',
	dateStart,
	dateEnd,
	blockchain = 'Unknown',
	count = 0,
	image = monaLisa,
	cardAdditionalProps = '',
	containerAdditionalProps = '',
	imageAdditionalProps = '',
	hasHoverEffect = true,
}: {
	name: string
	dateStart?: string
	dateEnd?: string
	blockchain?: string
	count?: number
	image: string
	cardAdditionalProps: string
	containerAdditionalProps: string
	imageAdditionalProps: string
	hasHoverEffect?: boolean
}) => {
	return (
		<div
			className={twMerge(
				'group h-[357px] w-[302px] border border-uiPrimaryLight dark:border-uiPrimaryDark dark:hover:border-textInactiveDark',
				hasHoverEffect
					? 'cursor-pointer hover:border-textInactiveLight dark:hover:border-textInactiveDark'
					: '',
				cardAdditionalProps,
			)}
		>
			<Image
				className={twMerge(
					'h-[240px] w-[302px] object-cover',
					imageAdditionalProps,
				)}
				containerClassName={containerAdditionalProps}
				imageUrl={image}
				imageAlt={name}
			></Image>
			<TypographyHeading
				size="small"
				isBold={true}
				additionalClasses={clsx(
					'w-full h-10 px-4 py-2 text-textPrimaryLight dark:text-textPrimaryDark truncate border-t border-uiPrimaryLight dark:border-uiPrimaryDark',
					hasHoverEffect
						? 'group-hover:underline group-hover:border-textInactiveLight dark:group-hover:border-textInactiveDark'
						: '',
				)}
			>
				{name}
			</TypographyHeading>
			{dateStart && (
				<div
					className={clsx(
						'flex h-10 gap-x-6 border-t border-uiPrimaryLight px-4 py-2 dark:border-uiPrimaryDark',
						hasHoverEffect
							? 'group-hover:border-textInactiveLight dark:group-hover:border-textInactiveDark'
							: '',
					)}
				>
					<TypographyParagraph
						size="small"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Start / End Date
					</TypographyParagraph>
					<TypographyParagraph
						size="small"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{dateStart}
						{dateEnd ? ` - ${dateEnd}` : ''}
					</TypographyParagraph>
				</div>
			)}
			<div className="flex flex-row">
				<div
					className={clsx(
						'flex h-9 flex-1 justify-between border-r border-t border-uiPrimaryLight px-4 py-2 dark:border-uiPrimaryDark',
						hasHoverEffect
							? 'group-hover:border-textInactiveLight dark:group-hover:border-textInactiveDark'
							: '',
					)}
				>
					<TypographyParagraph
						size="small"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Artworks
					</TypographyParagraph>
					<TypographyParagraph
						size="small"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{count > 10000 ? count.toLocaleString() : count}
					</TypographyParagraph>
				</div>
				<div
					className={clsx(
						'flex h-9 flex-1 justify-between border-t border-uiPrimaryLight px-4 py-2 dark:border-uiPrimaryDark',
						hasHoverEffect
							? 'group-hover:border-textInactiveLight dark:group-hover:border-textInactiveDark'
							: '',
					)}
				>
					<TypographyParagraph
						size="small"
						additionalClasses="w-[84px] text-textSecondaryLight dark:text-textSecondaryDark"
					>
						Blockchain
					</TypographyParagraph>
					<TypographyParagraph
						size="small"
						additionalClasses="text-textPrimaryLight dark:text-textPrimaryDark"
					>
						{blockchain}
					</TypographyParagraph>
				</div>
			</div>
		</div>
	)
}

export default EventCard
